<template>
  <div>
    <SettingsNavigation />

    <BaseWrapper>
      <BillingChoiceCard v-if="canSwitchToPerCandidate && paygSubscription" />
      <CandidateBillingCard v-if="isPerCandidate" />
      <PAYGPlansCard v-else />
    </BaseWrapper>
  </div>
</template>

<script>
import SettingsNavigation from '@components/Settings/SettingsNavigation'
import BillingChoiceCard from '@components/Plans/BillingChoiceCard'
import CandidateBillingCard from '@components/Plans/CandidateBillingCard'
import PAYGPlansCard from '@components/Plans/PAYGPlansCard'

import { mapGetters } from 'vuex'

/**
 * Annual-plan organisations keep their plans card and get the self-serve
 * switch above it while they hold a live plan; per-candidate organisations
 * see the pricing card.
 */
export default {
  components: {
    SettingsNavigation,
    BillingChoiceCard,
    CandidateBillingCard,
    PAYGPlansCard
  },

  computed: {
    ...mapGetters({
      isPerCandidate: 'organisations/isPerCandidate',
      canSwitchToPerCandidate: 'organisations/canSwitchToPerCandidate',
      paygSubscription: 'subscriptions/paygSubscription'
    })
  }
}
</script>
